import _m from './modules/mappings';
import _v from './modules/vars';
import _u from './modules/util';
import _fn from './modules/shared-fn';
import _filt from  './modules/filters';
import emailInit from './modules/email';
import './modules/render-widgets';
import progressInit from './modules/progress-nav';
import initPollSurvey from  './modules/qna';

// Set API Domain
if (_u.getDomain().indexOf('dev01') != '-1') {
	_v.slryApiDom = 'k8s.devint.';
} else if (_u.getDomain().indexOf('qa0') != '-1') {
	_v.slryApiDom = 'k8s.qa.';
} else if (_u.getDomain().indexOf('staging') != '-1') {
	_v.slryApiDom = 'k8s.staging.';
} else {
	_v.slryApiDom = 'k8s.';
}

document.addEventListener('unload', function(e) {
	window.scrollTo(0, 0);
});

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

function animateCompReport() {
	let elem = document.querySelector('.slry-comp-driver-img-wrap');
	if ((elem.getBoundingClientRect().top + elem.getBoundingClientRect().height/2) < window.innerHeight && (elem.getBoundingClientRect().bottom - elem.getBoundingClientRect().height/2) >= 0) {
		window.removeEventListener('scroll', animateCompReport);
		elem.classList.add('active');
	}
}

function bindCompReport() {
	document.removeEventListener('loadSalaryPage', bindCompReport);
	window.addEventListener('scroll', animateCompReport);
}

function handleVp(e) {
	 // IF called from submit button change URL + send VP tracking, ELSE URL-driven load...
	if (e.detail != null && e.detail.target != window) { // If a user clicked a submit button
		history.pushState(null, '', window.location.href.replace(window.location.search,'') + '?specialty=' + encodeURIComponent(_m.specMap[_v.homePageId].specialty) + '&city=' + encodeURIComponent(_v.userCity) + '&state=' + _v.userState + '&dma=' + encodeURIComponent(_v.userDma) + '&region=' + encodeURIComponent(_v.userRegion) + '&yoe=' + encodeURIComponent(_v.userYoeRng) + '&emp=' + _v.userEmpIdx);
		
		_fn.sendVpPageView(e);
		_fn.adLoadRefresh();
		document.title = _m.specMap[_v.homePageId].specialist + ' Salary in ' + _v.userCity + ', ' + _v.userState + '  | Medscape Salary Explorer';
	}
	else if (e.detail != null && e.detail.target == window) { // Else if a user clicked Back / Forward
		_fn.sendVpPageView();
		_fn.adLoadRefresh();
		document.title = _m.specMap[_v.homePageId].specialist + ' Salary in ' + _v.userCity + ', ' + _v.userState + '  | Medscape Salary Explorer';
	}
	else { // Else if user coming straight to Salary Results page
		_fn.adLoadRefresh(101);
	}
	
	// One time bind for Sticky filter
	if (e.detail == null || e.detail.target == window) {
		_filt.bindSticky();
	} else if (e.detail.parentNode.classList.contains('slry-welc')) {
		setTimeout(_filt.bindSticky, 300); // Delay Sticky Filter Bind for scroll-to-top
	}
	
}
document.addEventListener('loadSalaryPage', handleVp);
document.addEventListener('loadSalaryPage', bindCompReport);

_fn.checkQueryOnLoad();

// Handle Back Button with Debounce
let backDebounce = null;
window.addEventListener('popstate', function(e) {
	let event = e;
	clearTimeout(backDebounce);
	backDebounce = setTimeout(function() {		
		if (!_v.apiPending) {
			_fn.checkQueryOnLoad(event);
		} else {
			_v.apiPromise.then(function() {
				_v.apiPending = false;
				
				_fn.checkQueryOnLoad(event);
			});
		}	
	}, 500);
});

// Bind dropdowns, welcome screen validation and filters
_filt.bindFilters();

// Preload Active-state SVG
_u.preLoadImg(['//img.' + _u.getDomain() + 'medscapestatic.com/pi/features/salary-exp/icon-average-salary.svg', '//img.' + _u.getDomain() + 'medscapestatic.com/pi/features/salary-exp/icon-employed-on.svg', '//img.' + _u.getDomain() + 'medscapestatic.com/pi/features/salary-exp/icon-self-employed-on.svg']);

// Init Nav Dots / Indicator
progressInit();

// Survey/Poll code
initPollSurvey();

// Init Email This
emailInit();